import {
  FETCH_PATIENT_BY_ID_SUCCESS,
  FETCH_PATIENT_DOCTORS_SUCCESS,
  UPDATE_PATIENT_IMAGES,
  SHOW_SINGLE_PATIENT_MESSAGE,
  SHOW_SINGLE_PATIENT_LOADER,
  SHOW_SINGLE_PATIENT_IMAGE_LOADER,
  PATIENT_DELETE_IMAGES_SUCCESS,
  HIDE_SINGLE_PATIENT_LOADER,
  FETCH_PATIENT_HISTORY_SUCCESS,
  SHOW_SINGLE_PATIENT_HISTORY_LOADER,
  ADD_NEW_PAID_SUCCESS,
  ON_UPDATE_PATIENT_SUCCESS,
  SHOW_SAVING_INTERVENTIONS_BTN_LOADER,
  SAVE_INTERVENTIONS_SUCCESS,
} from 'constants/ActionTypes';

const INIT_STATE = {
  loader: true,
  apiLoaded: 2,
  imageLoader: false,
  alertMessage: '',
  showMessage: false,
  isErrorMessage: false,
  noPatientsFoundMessage: 'patients.noPatientsFound',
  patient: {},
  history: [],
  doctors: [],
  historyLoader: true,
  newInterventionsSaving: false
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_PATIENT_BY_ID_SUCCESS: {
      state.apiLoaded -= 1;
      let loader = true;
      if (state.apiLoaded === 0) {
        loader = false
        state.apiLoaded = 2
      }
      return {
        ...state,
        loader,
        patient: action.payload
      }
    }
    case FETCH_PATIENT_DOCTORS_SUCCESS: {
      state.apiLoaded -= 1;
      let loader = true;
      if (state.apiLoaded === 0) {
        loader = false
        state.apiLoaded = 2
      }
      return {
        ...state,
        loader,
        doctors: action.payload
      }
    }
    case SHOW_SINGLE_PATIENT_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload.message,
        isErrorMessage: action.payload.messageStatus,
        showMessage: true,
        loader: false,
        newInterventionsSaving: false
      }
    }
    case UPDATE_PATIENT_IMAGES: {
      const { patient } = state;
      if (!patient.images) {
        patient.images = [];
      }
      patient.images.push(action.payload);
      
      return { 
        ...state, 
        patient: patient,
        alertMessage: 'patient.imagesUploaded',
        isErrorMessage: false,
        showMessage: true,
        imageLoader: false 
      }
    }
    case SHOW_SINGLE_PATIENT_LOADER: {
      return { ...state, loader: true }
    }
    case SHOW_SINGLE_PATIENT_IMAGE_LOADER: {
      return { ...state, imageLoader: true }
    }
    case PATIENT_DELETE_IMAGES_SUCCESS: {
      const { patient } = state;
      const imageIndex = patient.images.findIndex((image) => {
        return image.id === action.payload.id
      })
      patient.images.splice(imageIndex, 1)

      return { 
        ...state, 
        patient: patient,
        alertMessage: 'patient.imagesDeleted',
        showMessage: true, 
        isErrorMessage: false, 
        imageLoader: false
      }
    }
    case HIDE_SINGLE_PATIENT_LOADER: {
      return { 
        ...state, 
        showMessage: false,
        alertMessage: '',
      };
    }
    case FETCH_PATIENT_HISTORY_SUCCESS: {
      return { 
        ...state, 
        historyLoader: false,
        history: action.payload
      };
    }
    case SHOW_SINGLE_PATIENT_HISTORY_LOADER: {
      return { 
        ...state, 
        historyLoader: true
      };
    }
    case ADD_NEW_PAID_SUCCESS: {
      const historyIndex = state.history.findIndex(review => review.id === action.payload.historyId)
      state.history[historyIndex].payments.push({
        id: action.payload.id,
        date: action.payload.date,
        paid: action.payload.paid,
      })

      return { 
        ...state, 
        historyLoader: false,
        alertMessage: 'patient.newPaidAdded',
        showMessage: true,
        isErrorMessage: false, 
      };
    }
    case ON_UPDATE_PATIENT_SUCCESS: {
      return { 
        ...state, 
        loader: false,
        patient: action.payload,
        alertMessage: 'patient.patientUpdated',
        showMessage: true,
        isErrorMessage: false
      };
    }
    case SHOW_SAVING_INTERVENTIONS_BTN_LOADER: {
      return { 
        ...state, 
        historyLoader: true,
        newInterventionsSaving: true,
      };
    }
    case SAVE_INTERVENTIONS_SUCCESS: {
      action.payload.doctorName = state.doctors.find(doctor => doctor.id === action.payload.doctorId).name
      state.history.unshift(action.payload)
      return { 
        ...state, 
        newInterventionsSaving: false,
        alertMessage: 'patient.newInterventionsAdded',
        showMessage: true,
        historyLoader: false,
        isErrorMessage: false
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/SinglePatient.js